import { get, post, patch } from 'utils/api';

export const getTermsAndConditions = () => get('/termsAndConditions');

export const createTermsAndCondition = (data) => post('/termsAndConditions', data);

export const updateTermsAndCondition = (id, data) => patch(`/termsAndConditions/${id}`, data);
